<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>以技术服务为核心，构建多元经营能力</h1>
      <p class="desc">
        我们以技术服务、技术开发与技术咨询为基础，延伸物联网研发、人工智能硬件、
        电子产品、珠宝首饰与日用百货等多元经营板块，并配套国内贸易代理、互联网销售、
        进出口代理与国际货物运输代理能力，为客户提供稳定可靠的合作支持。
      </p>
    </section>

    <div class="content-body">
      <section class="about-grid">
        <article class="card">
          <h3>技术服务</h3>
          <p>提供技术开发、技术咨询、技术交流、技术转让与技术推广，配套网络与信息技术咨询服务。</p>
        </article>
        <article class="card">
          <h3>产品与研发</h3>
          <p>聚焦物联网技术研发与技术服务、人工智能硬件、商用密码产品及其他电子器件制造与销售。</p>
        </article>
        <article class="card">
          <h3>贸易与流通</h3>
          <p>国内贸易代理、互联网销售、货物与技术进出口、进出口代理及国际货物运输代理一体化协同。</p>
        </article>
      </section>

      <section class="timeline">
        <h2>标准业务执行流程</h2>
        <div class="steps">
          <div class="step">
            <h4>01 / 需求沟通</h4>
            <p>明确技术需求、产品品类与交付目标，输出匹配的方案与报价路径。</p>
          </div>
          <div class="step">
            <h4>02 / 方案交付</h4>
            <p>推进技术开发、产品供应与渠道对接，按节点完成交付与验收。</p>
          </div>
          <div class="step">
            <h4>03 / 履约与复盘</h4>
            <p>跟进物流履约、售后支持与合作复盘，持续优化后续合作效率。</p>
          </div>
        </div>
      </section>

      <section class="metrics">
        <div class="metric">
          <p class="num">多品类</p>
          <p class="txt">涵盖技术、智能硬件、珠宝工艺与日用消费等经营方向</p>
        </div>
        <div class="metric">
          <p class="num">全链路</p>
          <p class="txt">从研发生产到贸易代理与物流履约的闭环服务</p>
        </div>
        <div class="metric">
          <p class="num">合规经营</p>
          <p class="txt">一般项目与许可项目均按规定依法开展</p>
        </div>
      </section>

      <section class="company">
        <h2>企业信息</h2>
        <ul class="company-list">
          <li>
            <span class="k">企业名称</span>
            <span class="v">茂名泓森网络科技有限公司</span>
          </li>
          <li>
            <span class="k">Enterprise</span>
            <span class="v">Maoming Hongsen Network Technology Co., Ltd.</span>
          </li>
          <li>
            <span class="k">统一社会信用代码</span>
            <span class="v">91440900MAEWCRJP6H</span>
          </li>
          <li>
            <span class="k">注册地址</span>
            <span class="v">茂名市电白区电城镇东街河东巷9号401房</span>
          </li>
          <li>
            <span class="k">Address</span>
            <span class="v">
              Room 401, No.9, Hedong Ln, East St, Diancheng, Dianbai Dist, Maoming City, Guangdong Province
            </span>
          </li>
        </ul>
      </section>

      <section class="company">
        <h2>经营范围</h2>
        <div class="scope-block">
          <h3 class="scope-title">一般项目</h3>
          <p class="scope-text">
            技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；国内贸易代理；网络技术服务；信息技术咨询服务；商用密码产品销售；商用密码产品生产；珠宝首饰制造；珠宝首饰零售；人工智能硬件销售；电子产品销售；工艺美术品及收藏品零售（象牙及其制品除外）；礼品花卉销售；日用百货销售；计算机软硬件及辅助设备零售；通讯设备销售；汽车零配件零售；货物进出口；技术进出口；国际货物运输代理；食品销售（仅销售预包装食品）；食品互联网销售（仅销售预包装食品）；互联网销售（除销售需要许可的商品）；其他电子器件制造；五金产品零售；服装服饰零售；户外用品销售；灯具销售；进出口代理；物联网技术研发；物联网技术服务。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">许可项目</h3>
          <p class="scope-text">
            道路货物运输（不含危险货物）。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutView"
};
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  color: #eff5f8;
}

.about-hero {
  margin-bottom: 48px;
  text-align: center;
}


h1 {
  margin: 12px 0 16px;
  font-size: 32px;
  line-height: 1.3;
}

.desc {
  margin: 0 auto;
  max-width: 640px;
  color: #9ab0bc;
  line-height: 1.8;
  font-size: 15px;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

h2 {
  margin: 0 0 24px;
  font-size: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.about-grid {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
}

.card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ff6f2c;
}

.card p, .step p {
  margin: 0;
  line-height: 1.7;
  color: #9ab0bc;
  font-size: 14px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.metrics {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 32px;
}

.metric {
  text-align: center;
}

.num {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #ffb684;
}

.txt {
  margin: 0;
  color: #9ab0bc;
  line-height: 1.5;
  font-size: 14px;
}

.company-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.company-list li {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.company-list .k {
  color: #ffb684;
  font-size: 13px;
  font-weight: 700;
}

.company-list .v {
  color: #eff5f8;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}

.scope-block {
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scope-block + .scope-block {
  margin-top: 12px;
}

.scope-title {
  margin: 0 0 8px;
  font-size: 15px;
  color: #ff6f2c;
}

.scope-text {
  margin: 0;
  color: #9ab0bc;
  font-size: 14px;
  line-height: 1.9;
}

@media (max-width: 640px) {
  .company-list li {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

@media (max-width: 768px) {
  .about-grid, .metrics {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
